require('jquery');
import Form from '../class/Form';
import SearchDropdown from 'src/class/SearchDropdown';

class Post {
	constructor(className) {
		const sections = document.querySelectorAll(`.${className}`);
		this.copyToClipboard();

		sections.forEach((section) => {
			const commentForm = section.querySelector('.comment-form');
			if (commentForm) new Form(commentForm, { preventSubmit: false });
		});

		// const searchForm = document.querySelector('.search__form');
		// searchForm.addEventListener('submit', (e) => e.stopPropagation());
		// const searchInput = searchForm.querySelector('input');
		// new SearchDropdown(searchInput, {
		// 	anchorElement: searchForm,
		// });

		const tocs = document.querySelectorAll('.table-contents__title');
		tocs.forEach((toc) => {
			toc.addEventListener('click', () => {
				const tableOfContents = document.querySelector('.table-contents__container');
				tableOfContents.classList.toggle('open');
			});
		});
	}
	copyToClipboard() {
		const buttonsCopy = document.querySelectorAll('.linkedBtn');
		const categories = document.querySelectorAll('.single-post__category');
		const date = document.querySelector('.post__header-date');
		const dateValue = date.innerText;
		const dateRealValue = dateValue.replace(/\s/g, '-');

		const categoryRealValue = Object.values(categories)
			.map((category) => {
				const categoryValue = category.innerText;
				return categoryValue.replace(/\//g, '').replace(/\s/g, '').replace(/[?&]/g, '+').toLowerCase();
			})
			.join('+');

		buttonsCopy.forEach((buttonCopy) => {
			buttonCopy.addEventListener('click', function (ev) {
				var inputc = document.body.appendChild(document.createElement('input'));
				var utmMedium = 'utm_medium=referral';
				var utmSource = 'utm_source=' + window.location.hostname;
				var utmCampaign = 'utm_campaign=blog';
				var utmTerm = 'utm_terms=' + categoryRealValue;
				var utmContent = 'utm_content=sharelink';
				inputc.value =
					window.location.href +
					'?' +
					utmMedium +
					'&' +
					utmSource +
					'&' +
					utmCampaign +
					'&' +
					utmContent +
					'&' +
					utmTerm;

				inputc.focus();
				inputc.select();
				document.execCommand('copy');
				inputc.parentNode.removeChild(inputc);
				window.scrollTo(0, 0);
				const copiedModals = document.querySelectorAll('.linked-modal');
				copiedModals.forEach((copiedModal) => {
					copiedModal.classList.add('active');
				});
			});
		});
	}
}

export default Post;
